var map = {
	"./bg_blue_left.png": "7dc7",
	"./bg_blue_right.png": "7038",
	"./bg_green.png": "25b2",
	"./btn_add.png": "7126",
	"./btn_bangzhu_fenlei.png": "ce36",
	"./btn_bangzhu_liebiao.png": "c467",
	"./btn_chanpin_liebiao.png": "4142",
	"./btn_chanpin_shenhe.png": "3a15",
	"./btn_chanping_fenlei.png": "445f",
	"./btn_chanping_huishouzhan.png": "8efe",
	"./btn_chanping_leixing.png": "f642",
	"./btn_chanping_pingpai.png": "0be4",
	"./btn_huiyuan_dengji.png": "b63b",
	"./btn_huiyuan_liebiao.png": "8059",
	"./btn_huiyuan_renwu.png": "2811",
	"./btn_tongji_chanping.png": "202a",
	"./btn_tongji_huiyuan.png": "0544",
	"./btn_tongji_liuliang.png": "16a0",
	"./btn_tongji_sousuo.png": "ddbd",
	"./btn_xiaoxishezhi.png": "ded4",
	"./btn_yonghu_juese.png": "acf0",
	"./btn_yonghu_liebiao.png": "5130",
	"./daiban_icon_shenpi.png": "392c",
	"./daiban_icon_weitongguo.png": "6dd2",
	"./home_icon_chanping.png": "c43e",
	"./home_icon_user.png": "e2c9",
	"./icon_chanpinggengxin.png": "7179",
	"./icon_gonggao.png": "2799"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "197f";